import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Hero.css';
import heroImage from '../../assets/images/hero.jpg';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <img src={heroImage} alt="Yoga Studio" className="hero-img" />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">

        <motion.h1 
          className="hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Transform Your Mind,<br/>Body & Soul Through Yoga
        </motion.h1>
        
        <motion.p
          className="hero-desc"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Experience the perfect harmony of movement, mindfulness, and meditation. Whether you're beginning your yoga journey or deepening your practice, our expert instructors are here to guide you toward a healthier and more balanced life.
        </motion.p>

        <motion.div 
          className="hero-actions"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <Link to="/appointment" className="btn-primary">Book a Class</Link>
          <Link to="/classes" className="btn-secondary">Explore Classes</Link>
        </motion.div>


      </div>
    </section>
  );
};

export default Hero;
